<template>
  <custom-dialog width="1280px" class="accounts-receivable-dialog" :visible="visible" :append-to-body="true" v-on="$listeners" :title="model.title">
    <div class="dialog-body">
      <div class="item-title">{{ $t('dr_select1_yfyjxx') }}</div>
      <div class="table-bd">
        <custom-table :data="tableList" tableCode="portal_deposit_refund_select" type="checkbox" v-model="selectList" @filter="filterChange" @sort="sortChange"></custom-table>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <el-button @click="onCancel">{{ $t('com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('dr_select1_que_ren') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

// dr_select1_yfyjxx: 应付押金信息// dr_select1_que_ren: 确认

export default {
  name: '',
  mixins: [dialogMixins],
  data() {
    return {
      tableList: [],
      selectList: [],
    };
  },
  mounted() {
    this.mergeLanguage(null, 'portal_deposit_refund_select_dialog');
    this.getTableList();
    // this.getCompLanguage();
  },
  methods: {
    getReqData() {
      const data = this.model.data;
      return {
        existBillIds: data.existBillIds,
        payableOrgId: data.payableOrgId,
        receivableOrgId: data.receivableOrgId,
      };
    },
    getTableList() {
      const reqData = this.getReqData();
      this.$getJSON(apis.DepositRefundList, reqData).then((res) => {
        const list = res.data;
        this.tableList = list;
      });
    },
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    onConfirm() {
      this.closeDialog();
      this.$emit('confirm', this.selectList);
    },
  },
};
</script>

<style></style>
